/* eslint-disable */
export const isYouTube = (src = '') =>
  /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/gim.test(src);

export const getPasswordRegex = (isLdapLogin: boolean) =>
  isLdapLogin ? /^[-a-zA-Zа-яА-Я0-9!@#$%^&*()_+=\[\]\/{};:"',.<>?]/ : /^[a-zA-Z0-9!@#$%^&*]/;

export const getPasswordRegexWithMinLength = (isLdapLogin: boolean) =>
  isLdapLogin ? /^[-a-zA-Zа-яА-Я0-9!@#$%^&*()_+=-[~\]\/{};:"',.<>?]{6,}$/ : /^[a-zA-Z0-9!@#$%^&*]{6,}$/;

export const getValidateEmail = (src = '') => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]$/i.test(src);
